async function readJsonResponse(response, url) {
  const text = await response.text()
  const trimmed = text.trim()

  if (!response.ok) {
    throw new Error(`${url} returned ${response.status}`)
  }

  if (trimmed.startsWith('<')) {
    throw new Error(`${url} returned HTML instead of JSON`)
  }

  return JSON.parse(text)
}

function uniqueUrls(urls) {
  return urls.filter((url, index) => url && urls.indexOf(url) === index)
}

export async function loadJsonFromApi(apiBaseUrl, path) {
  const baseUrl = (apiBaseUrl || '').replace(/\/$/, '')
  const candidates = uniqueUrls([
    `${baseUrl}${path}`,
    path,
  ])

  const errors = []
  for (const url of candidates) {
    try {
      const response = await fetch(url)
      return await readJsonResponse(response, url)
    } catch (error) {
      errors.push(error.message)
    }
  }

  throw new Error(`API load failed. Tried: ${errors.join('; ')}`)
}

export async function loadWorldGeojson(apiBaseUrl) {
  const baseUrl = (apiBaseUrl || '').replace(/\/$/, '')
  const candidates = uniqueUrls([
    `${baseUrl}/data/world.topo.geojson`,
    `${baseUrl}/static/geo/world.topo.geojson`,
    '/data/world.topo.geojson',
    '/static/geo/world.topo.geojson',
  ])

  const errors = []
  for (const url of candidates) {
    try {
      const response = await fetch(url)
      return await readJsonResponse(response, url)
    } catch (error) {
      errors.push(error.message)
    }
  }

  throw new Error(`World map load failed. Tried: ${errors.join('; ')}`)
}
